import PropTypes from 'prop-types';

import { ErrorBoundary } from '@zenbusiness/application-commons-logging';
import Stack from '@zenbusiness/zui/Stack';

import { ErrorStateSection } from '#client/components/ErrorStateSection';
import { HomeBanners } from '#client/components/HomeBanners';
import { NextUp } from '#client/components/NextUp';
import { OrderTracker } from '#client/components/OrderTracker';
import { PersonalizedModal } from '#client/components/PersonalizedModal';
import { ProductCategories } from '#client/components/ProductCategories';
import { useShowCarousel } from '#client/hooks/useShowCarousel';

import { Carousel } from './Carousel';
import { StyledPageContainer } from './Home.styles';
import DashboardWidgets from '../../components/Widgets/DashboardWidgets';

const Home = ({
  loading
}) => {
  const { shouldShow: showCarousel } = useShowCarousel();

  return (
    <StyledPageContainer>
      <Stack spacing={{ xs: 2, sm: 3 }}>

        <HomeBanners />

        <ErrorBoundary id="src/Home#NextUp" fallback={<ErrorStateSection title="Next Up" />}>
          <NextUp />
        </ErrorBoundary>

        <ErrorBoundary id="src/Home#OrderStatus" fallback={<ErrorStateSection title="Order Status" />}>
          <OrderTracker />
        </ErrorBoundary>

        {showCarousel && (
          <ErrorBoundary id="src/Home#Carousel" fallback={<ErrorStateSection />}>
            <Carousel />
          </ErrorBoundary>
        )}

        <ErrorBoundary id="src/Home#Widgets" fallback={<ErrorStateSection />}>
          <DashboardWidgets />
        </ErrorBoundary>

        <ErrorBoundary id="src/Home#ProductCards" fallback={<ErrorStateSection title="Products for your business" />}>
          <ProductCategories />
        </ErrorBoundary>
      </Stack>

      {!loading && (
      <ErrorBoundary id="src/Home#PersonalizedModal" fallback={<ErrorStateSection />}>
        <PersonalizedModal />
      </ErrorBoundary>
      )}

    </StyledPageContainer>
  );
};

Home.propTypes = {
  loading: PropTypes.bool
};

export default Home;
